import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../_services/admin.service';
import { ConfirmationDialogService } from '../../_services/confirmation-dialog.service';
import { GlobalDataService } from '../../_shared/global-data.service';
import { NgbModal, NgbDateAdapter, NgbDateNativeAdapter,NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { TransCompliance, MstCompliance, User, LoginUser } from '../../_models';
import { ModalPopupAlertComponent } from '../../_shared/modal-popup-alert/modal-popup-alert.component';


@Component({
  selector: 'app-set-compliance',
  templateUrl: './set-compliance.component.html',
  styleUrls: ['./set-compliance.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class SetComplianceComponent implements OnInit {

  
  model1!: Date;
  model2!: Date;

  get today() {
    return new Date();
  }
  transCompliance = new TransCompliance();
  transCompliances: TransCompliance[] = [];
  mstCompliances: MstCompliance[] = [];
  curdate!: string;
   Id=0;
   ComplianceId=0;
   CompType: any;  
   CreatedDate!: Date;
   FromDt!: Date;
   ToDt!: Date;
   CreatedBy='Admin';
   UpdatedDate ?  : Date;
   UpdatedBy!: string;
  user!: LoginUser;
  constructor(
    private adminService  : AdminService,
    private confirmationDialogService: ConfirmationDialogService,
    private gd : GlobalDataService,
    private modalService: NgbModal,
    private calendar: NgbCalendar
  ) { }

  

  ngOnInit() {
this.curdate = this.gd.monthNames[new Date().getMonth()]  +"-"+ new Date().getFullYear();
    this.getAllMstComp();
    this.user = this.gd.getUserData();
  }

  getAllMstComp()
  {
    this.adminService.viewMstCompliance().subscribe(data=>{
      this.mstCompliances = data;
    });
  }
 

  public updateConfirm(updateCompliance : MstCompliance) {
    this.confirmationDialogService.confirm('Please confirm..', 'Do you really want to Update. ?')
    .then((confirmed) => {if(confirmed==true){this.updateCompliance(updateCompliance)}})
    .catch(() => {});
  }
  updateCompliance(updateCompliance : MstCompliance) {
    
    this.adminService.UpdateCompliance(updateCompliance).subscribe(res => {
      this.getAllMstComp();
      this.openAlertModal("Record Updated Successfully")
    });
  }

  openAlertModal(strmsg: string) {
    const modalRef = this.modalService.open(ModalPopupAlertComponent);
    modalRef.componentInstance.strText = strmsg;
    modalRef.result.then((result) => {
    }, (reason) => {
    });   
  }
  Selected()
{
}

isDefined(value:any) {return typeof value !== 'undefined';}

}
